import React from 'react';
import styled from 'styled-components';
import DOMPurify from 'dompurify';

interface HTMLViewerProps {
  html: string | Node;
}

function HTMLViewer({ html }: HTMLViewerProps) {
  const sanitizedHTML = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'a',
      'b',
      'i',
      'em',
      'strong',
      'span',
      'br',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'body',
      'ul',
      'ol',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'style'],
  });

  return <Content dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
}

const Content = styled.div`
  ol,
  ul {
    margin-left: 16px;
  }

  p,
  ul,
  ol {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  h1 {
    font-size: 20px;
  }

  h2 {
    font-size: 17px;
  }

  h3 {
    font-size: 15px;
  }

  h1,
  h2,
  h3 {
    margin: 10px 0;
  }
`;

export { HTMLViewer };
